module.exports = __webpack_public_path__ + "static/media/ELTENEMO_FINAL-Bleu-Sigle.665ee392.png";